/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import moment from 'moment';
import HorizontalChart from './HorizontalChart';
import { addAlpha } from '../../../../utils/helpers';

const getMaximum = (data) => {
  let max = 0;

  Object.keys(data).forEach((hour) => {
    const hourData = data?.[hour];
    const { Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday } = hourData;

    if (max < Sunday) {
      max = Sunday
    }
    if (max < Monday) {
      max = Monday
    }
    if (max < Tuesday) {
      max = Tuesday
    }
    if (max < Wednesday) {
      max = Wednesday
    }
    if (max < Thursday) {
      max = Thursday
    }
    if (max < Friday) {
      max = Friday
    }
    if (max < Saturday) {
      max = Saturday
    }
  })

  return max
}

const returnColorWithOpacity = (max, num) => {

  const dividend = Number(Number(num / max).toFixed(2));

  if (dividend === 1) {
    return 1
  }

  if (dividend < 1 && dividend > 0.9) {
    return 0.9
  }

  if (dividend <= 0.9 && dividend > 0.8) {
    return 0.8
  }

  if (dividend <= 0.8 && dividend > 0.7) {
    return 0.7
  }

  if (dividend <= 0.7 && dividend > 0.6) {
    return 0.6
  }

  if (dividend <= 0.6 && dividend > 0.5) {
    return 0.5
  }

  if (dividend <= 0.5 && dividend > 0.4) {
    return 0.4
  }

  if (dividend <= 0.4 && dividend > 0.3) {
    return 0.35
  }

  if (dividend <= 0.3 && dividend > 0.2) {
    return 0.29
  }

  if (dividend <= 0.2 && dividend > 0.1) {
    return 0.23
  }

  return 0.15

}


const BestTimeChart = ({
  dir, data,
}) => {

  const renderData = () => {
    const tableData = [];

    const max = getMaximum(data);

    for (let hour = 0; hour < 24; hour += 1) {
      const hourData = data?.[hour];
      tableData.push(
        <tr className="graph_table_row" key={hour}>
          <td className="graph_table_row_td" style={{ width: '90px' }}>{`${moment(hour, 'h').format('HH:mm A')}-${moment(hour + 1, 'h').format('HH:mm A')}`}</td>
          <td className="graph_table_row_td" style={{ width: '120px' }}>
            <HorizontalChart data={[{ day: 'Sunday', Count: hourData?.Sunday, color: addAlpha('#3366ff', returnColorWithOpacity(max, hourData?.Sunday)) }]} max={max} /></td>
          <td className="graph_table_row_td" style={{ width: '120px' }}>
            <HorizontalChart data={[{ day: 'Monday', Count: hourData?.Monday, color: addAlpha('#3366ff', returnColorWithOpacity(max, hourData?.Sunday)) }]} max={max} /></td>
          <td className="graph_table_row_td" style={{ width: '120px' }}>
            <HorizontalChart data={[{ day: 'Tuesday', Count: hourData?.Tuesday, color: addAlpha('#3366ff', returnColorWithOpacity(max, hourData?.Sunday)) }]} max={max} /></td>
          <td className="graph_table_row_td" style={{ width: '120px' }}>
            <HorizontalChart data={[{ day: 'Wednesday', Count: hourData?.Wednesday, color: addAlpha('#3366ff', returnColorWithOpacity(max, hourData?.Sunday)) }]} max={max} /></td>
          <td className="graph_table_row_td" style={{ width: '120px' }}>
            <HorizontalChart data={[{ day: 'Thursday', Count: hourData?.Thursday, color: addAlpha('#3366ff', returnColorWithOpacity(max, hourData?.Sunday)) }]} max={max} /></td>
          <td className="graph_table_row_td" style={{ width: '120px' }}>
            <HorizontalChart data={[{ day: 'Friday', Count: hourData?.Friday, color: addAlpha('#3366ff', returnColorWithOpacity(max, hourData?.Sunday)) }]} max={max} /></td>
          <td className="graph_table_row_td" style={{ width: '120px' }}>
            <HorizontalChart data={[{ day: 'Saturday', Count: hourData?.Saturday, color: addAlpha('#3366ff', returnColorWithOpacity(max, hourData?.Sunday)) }]} max={max} /></td>
        </tr>
      )
    }

    return tableData;
  }

  return (
    <Col xs={12} className="p-4" >
      <div className="card__title mb-2">
        <h5 className="bold-text">Best Times</h5>
      </div>
      <table className="graph_table mt-2">
        <tr className="graph_table_row">
          <th className="graph_table_row_th_1">Hour</th>
          <th className="graph_table_row_th" style={{ width: '120px' }}> Sunday</th>
          <th className="graph_table_row_th" style={{ width: '120px' }}> Monday</th>
          <th className="graph_table_row_th" style={{ width: '120px' }}> Tuesday</th>
          <th className="graph_table_row_th" style={{ width: '120px' }}> Wednesday</th>
          <th className="graph_table_row_th" style={{ width: '120px' }}> Thursday</th>
          <th className="graph_table_row_th" style={{ width: '120px' }}> Friday</th>
          <th className="graph_table_row_th" style={{ width: '120px' }}> Saturday</th>
        </tr>
        {renderData()}

      </table>
    </Col>
  );
};

BestTimeChart.propTypes = {
  dir: PropTypes.string.isRequired,
  data: PropTypes.objectOf({}).isRequired,

};


export default BestTimeChart;
